module.exports = __webpack_public_path__ + "static/cot1bath-85a9d8abbe9eb80688dbdb1e76bf68ff.jpg";